import bunyan from 'bunyan';
import getConfig from 'next/config';

const { serviceName } = getConfig().publicRuntimeConfig.datadog;

export const logger = bunyan.createLogger({
  name: serviceName,
});
